import { COOKIE_ACCESS_TOKEN } from '@danone-global/internal/graphql'
import { analytics, useCore } from '@danone-global/internal/react/core'
import md5 from 'js-md5'
import React from 'react'
import Cookies from 'universal-cookie'

export const useReviewRating = (
  refetchReviews,
  sku: string,
  productName: string,
  withAnalytics: boolean,
) => {
  const reviewsRated = React.useRef({})
  const { apiUrl } = useCore()

  const callApi = (reviewId: string, rating: boolean) => {
    const cookies = new Cookies()
    const accessToken = cookies.get(COOKIE_ACCESS_TOKEN)

    return fetch(`${apiUrl}/review_commercetools/rate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        reviewId,
        userRating: rating,
        userRatingUniquenessValues: `${reviewId}:${md5(
          accessToken + 'reviewrating',
        )}`,
        clientAccessToken: accessToken,
      }),
    })
  }

  const handleUpvote = async (id: string) => {
    if (reviewsRated.current[id]) {
      return
    } else {
      reviewsRated.current[id] = true
    }

    await callApi(id, true)
    await refetchReviews()

    if (withAnalytics) {
      analytics.push({
        action: 'RECOMMEND_REVIEW',
        event: "recommend_review",
        ecommerce: {
          reviewId: id,
          name: productName,
          sku,
        }       
      })
    }
  }

  const handleDownVote = async (id: string) => {
    if (reviewsRated.current[id]) {
      return
    } else {
      reviewsRated.current[id] = true
    }

    await callApi(id, false)
    await refetchReviews()

    if (withAnalytics) {
      analytics.push({
        action: 'DISCOMMEND_REVIEW',
        event: 'discommend_review',
        ecommerce: {
          reviewId: id,
          item_name: productName,
          item_id: sku,
        }
      })
    }
  }

  return {
    upvote: handleUpvote,
    downVote: handleDownVote,
  }
}
